interface AllergensList {
  img: string
  name_es: string
  name_en: string
  name_fr: string
  name_ca: string
  name_de: string
  name_eu: string
}

const ALLERGEN_NAME_KEYS = ['es', 'en', 'fr', 'ca', 'de', 'eu'] as const

export const allergensList: Record<string, AllergensList> = {
  altramuces: {
    img: '/img/allergens/altramuces.svg',
    name_es: 'altramuces',
    name_en: 'lupins',
    name_fr: 'lupins',
    name_ca: 'tramussos',
    name_de: 'Lupinen',
    name_eu: 'lupuluak'
  },
  apio: {
    img: '/img/allergens/apio.svg',
    name_es: 'apio',
    name_en: 'celery',
    name_fr: 'céleri',
    name_ca: 'api',
    name_de: 'Sellerie',
    name_eu: 'apioa'
  },
  cacahuetes: {
    img: '/img/allergens/cacahuetes.svg',
    name_es: 'cacahuetes',
    name_en: 'peanuts',
    name_fr: 'arachides',
    name_ca: 'cacauets',
    name_de: 'Erdnüsse',
    name_eu: 'kakahueteak'
  },
  crustaceos: {
    img: '/img/allergens/crustaceos.svg',
    name_es: 'crustaceos',
    name_en: 'crustaceans',
    name_fr: 'crustacés',
    name_ca: 'crustacis',
    name_de: 'Krebstiere',
    name_eu: 'krustazeoak'
  },
  huevos: {
    img: '/img/allergens/huevos.svg',
    name_es: 'huevos',
    name_en: 'eggs',
    name_fr: 'oeufs',
    name_ca: 'ous',
    name_de: 'Eier',
    name_eu: 'arrautzak'
  },
  lacteo: {
    img: '/img/allergens/lacteo.svg',
    name_es: 'lácteo',
    name_en: 'dairy',
    name_fr: 'lait',
    name_ca: 'làctic',
    name_de: 'Milch',
    name_eu: 'esnekiak'
  },
  molusco: {
    img: '/img/allergens/molusco.svg',
    name_es: 'molusco',
    name_en: 'molluscs',
    name_fr: 'mollusques',
    name_ca: 'mol·lusc',
    name_de: 'Weichtiere',
    name_eu: 'moluskuak'
  },
  mostaza: {
    img: '/img/allergens/mostaza.svg',
    name_es: 'mostaza',
    name_en: 'mustard',
    name_fr: 'moutarde',
    name_ca: 'mostassa',
    name_de: 'Senf',
    name_eu: 'mostaza'
  },
  'frutos con cáscara': {
    img: '/img/allergens/frutos con cáscara.svg',
    name_es: 'frutos con cáscara',
    name_en: 'nuts with shell',
    name_fr: 'fruits à coque',
    name_ca: 'fruits amb closca',
    name_de: 'Schalenfrüchte',
    name_eu: 'fruitu lehorrak'
  },
  pescado: {
    img: '/img/allergens/pescado.svg',
    name_es: 'pescado',
    name_en: 'fish',
    name_fr: 'poisson',
    name_ca: 'peix',
    name_de: 'Fisch',
    name_eu: 'arrainak'
  },
  sesamo: {
    img: '/img/allergens/sesamo.svg',
    name_es: 'sésamo',
    name_en: 'sesame',
    name_fr: 'sésame',
    name_ca: 'sèsam',
    name_de: 'Sesam',
    name_eu: 'sesamoa'
  },
  soja: {
    img: '/img/allergens/soja.svg',
    name_es: 'soja',
    name_en: 'soy',
    name_fr: 'soja',
    name_ca: 'soja',
    name_de: 'Soja',
    name_eu: 'soja'
  },
  gluten: {
    img: '/img/allergens/gluten.svg',
    name_es: 'gluten',
    name_en: 'gluten',
    name_fr: 'gluten',
    name_ca: 'gluten',
    name_de: 'Gluten',
    name_eu: 'gluten'
  },
  sulfitos: {
    img: '/img/allergens/sulfitos.svg',
    name_es: 'sulfitos',
    name_en: 'sulfites',
    name_fr: 'sulfites',
    name_ca: 'sulfits',
    name_de: 'Sulfite',
    name_eu: 'sulfitoak'
  }
}

export const getAllergenName = (allergenKey: string, language: string): string => {
  const entry = allergensList[allergenKey]
  if (!entry) return allergenKey
  const normalized = (ALLERGEN_NAME_KEYS as readonly string[]).includes(language) ? language : 'en'
  const key = `name_${normalized}` as keyof AllergensList
  return entry[key] || entry.name_en || entry.name_es
}
